import React from "react"
import useT from "../hooks/useT"
import useAsync from "../hooks/useAsync"
import { UserInvoices } from "../storeApi"
import { Section, Card, Empty, Loading, ErrorText, formatDate, formatMoney } from "./ui"
import { openOrderDocument } from "./orderDocument"

/** Receipts / invoices (customer {invoices}): Stripe's, one per payment, and the sellers' own on orders paid on delivery. */
export default function Invoices() {
  const t = useT()
  const { result, pending } = useAsync(() => UserInvoices(), [])
  const invoices = result?.invoices || []

  return (
    <Section title={t`Invoices`}>
      {pending && !result && <Loading />}
      <ErrorText>{result?.error}</ErrorText>
      {result && !result.error && invoices.length === 0 && <Empty>{t`No invoices yet.`}</Empty>}
      {invoices.map((invoice, i) => (
        <Card key={i} className="flex flex-row flex-wrap items-center justify-between gap-3">
          <div className="flex flex-col">
            <span className="flex items-center gap-2 font-bold">
              <span className={`inline-flex h-[22px] items-center rounded-full px-2.5 text-[11px] font-bold uppercase text-white ${invoice.type === "invoice" ? "bg-primary" : "bg-success"}`} data-testid="invoice-type">
                {invoice.type === "invoice" ? t`Invoice` : t`Receipt`}
              </span>
              {t`Order Numbers:`} #{(invoice.orderNumbers || []).join(", #")}
            </span>
            <span className="text-[13px] text-text_secondary">
              {formatDate(invoice.date)}
              {invoice.companyName ? ` · ${t`Company`}: ${invoice.companyName}` : ""}
            </span>
          </div>
          <div className="flex items-center gap-4">
            <span className="font-bold">{formatMoney(invoice.amount, invoice.currency)}</span>
            {invoice.invoiceUrl ? (
              <a href={invoice.invoiceUrl} target="_blank" rel="noopener noreferrer" className="font-bold text-primary hover:underline">
                {t`Download`}
              </a>
            ) : (
              // a seller's PDF: its bytes come through the order (customer {order_invoice})
              <button type="button" onClick={() => openOrderDocument(invoice.orderRef)} className="font-bold text-primary hover:underline">
                {t`Download`}
              </button>
            )}
          </div>
        </Card>
      ))}
    </Section>
  )
}
